export default {
  profileData: state => state.data
}
